import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Education Software Development Company Offer?",
      a: "We offer comprehensive education software development services, including Learning Management System (LMS) development, interactive course content creation, virtual classroom solutions, and more.",
    },
    {
      q: "Can You Develop a Custom Learning Management System (Lms) for Our Educational Institution?",
      a: "Absolutely. We specialize in developing customized LMS solutions tailored to the unique needs and requirements of educational institutions.",
    },
    {
      q: "What Types of Educational Software Solutions Do You Specialize in?",
      a: "We specialize in various educational software solutions, including interactive courseware development, virtual classrooms, assessment tools, and learning analytics platforms.",
    },
    {
      q: "How Do You Ensure the Security and Privacy of Student Data in Your Software Solutions?",
      a: "We prioritize the security and privacy of student data by implementing robust authentication measures, encryption protocols, and compliance with data protection regulations.",
    },
    {
      q: "Can Your Software Solutions Integrate With Existing Educational Systems or Platforms?",
      a: "Yes, our software solutions are designed to seamlessly integrate with existing educational systems, databases, and platforms to ensure interoperability.",
    },
    {
      q: "What Technologies Do You Use for Educational Software Development?",
      a: "We leverage cutting-edge technologies and development frameworks to create scalable, secure, and feature-rich educational software solutions.",
    },
    {
      q: "How Do You Ensure the User-friendliness of Your Educational Software?",
      a: "User experience (UX) is a key focus in our development process. We conduct usability testing, gather feedback, and iteratively improve the interface for optimal user-friendliness.",
    },
    {
      q: "Can You Provide Examples of Educational Software Projects You Have Successfully Developed?",
      a: "Certainly. We can share case studies and examples of educational software projects during our initial consultation.",
    },
    {
      q: "Do You Offer Ongoing Support and Maintenance Services for the Educational Software You Develop?",
      a: "Yes, we provide comprehensive support and maintenance services to ensure the continued efficiency and reliability of the educational software we develop.",
    },
    {
      q: "How Do You Approach the Customization of Educational Software Based on the Specific Needs of Our Institution?",
      a: "We conduct thorough consultations to understand the unique requirements of your institution. Our development process includes customization to align with your specific goals and preferences.",
    },
    {
      q: "What is the Typical Timeline for Developing an Educational Software Solution?",
      a: "The timeline varies based on the complexity and features required. We provide detailed project timelines during the initial planning and consultation phase.",
    },
    {
      q: "Can Your Educational Software Solutions Support Remote Learning and Virtual Classrooms?",
      a: "Yes, our educational software solutions are designed to support remote learning, virtual classrooms, and collaborative online environments.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
